export default __webpack_public_path__ + "static/media/open-eye.45407ee6.svg";